// extracted by mini-css-extract-plugin
module.exports = {"root":"Stories-root-35a62e9ebca01004a515f7718e3719a4"};